import SubmitCard from "./components/SubmitCard";
import Distribution from "./components/Distribution";
import HunterBoxList from "./components/HunterBoxList";
import HunterBoxHealth from "./components/HunterBoxHealth";
import ContainerServices from "../../Components/PagesComponents/Dashboard/ContainerServices/ContainerServices";


import "./styles.scss";

const HunterBox = () => {
  return (
    <div className="hunterbox">
      <div className="hunterbox__header">
        <h1>HunterBox</h1>
      </div>
      <div className="hunterbox__body">
        <SubmitCard />
        <Distribution />
        <HunterBoxList />
        <div className="hunterbox__body__services-container">
          <HunterBoxHealth />
          <ContainerServices />
        </div>
      </div>
    </div>
  );
};

export default HunterBox;
